import {getSites} from '@/api/admin';
import {useQuery} from '@tanstack/react-query';

export function useAdminSites(page: number = 1, search: string = '', status: string = '') {
    return useQuery({
        queryKey: ['admin', 'sites', {page, search, status}],
        queryFn: () => getSites(page, search, status),
        keepPreviousData: true
    });
}
